/**
 * Base URL for Netlify functions (no trailing slash).
 * Leave unset in production on Netlify (same origin as the React app).
 * Local: run `netlify dev` and set e.g. REACT_APP_NETLIFY_FUNCTIONS_BASE=http://localhost:8888
 */
export function getNetlifyFunctionsBase() {
  return (process.env.REACT_APP_NETLIFY_FUNCTIONS_BASE || "").trim().replace(/\/+$/, "");
}

export function getCreateCheckoutSessionUrl() {
  const base = getNetlifyFunctionsBase();
  const path = "/.netlify/functions/create-checkout-session";
  if (!base) return path;
  return `${base}${path}`;
}

/** Contact form POST — optional; falls back to mailto in the UI if unavailable. */
export function getSubmitContactUrl() {
  const base = getNetlifyFunctionsBase();
  const path = "/.netlify/functions/submit-contact";
  if (!base) return path;
  return `${base}${path}`;
}

/** Ingredient community note POST (moderated; requires Supabase table + service role on Netlify). */
export function getSubmitIngredientNoteUrl() {
  const base = getNetlifyFunctionsBase();
  const path = "/.netlify/functions/submit-ingredient-note";
  if (!base) return path;
  return `${base}${path}`;
}
